module.exports = __webpack_public_path__ + "img/oAsxXGqo.38c63c3e.svg";